import React from 'react';
import './App.css';

import Home from './Home';
import Daily from './Daily';
import Practice from './Practice';

// import data from './data/words';
import data from './data/full_words';
import translations from './translations/translations';

class App extends React.Component {

  constructor(props) {
    super(props);

    let wordData = this.generateWordData(data);

    this.state = {
      "difficulty": 'medium',
      "chances": 6,
      "incorrectGuesses": 0,
      // "word": this.generateWord(data),
      "wordData": wordData,
      "word": wordData["word"].toLowerCase(),
      "definition": wordData["definition"],
      "lang": wordData["language"],
      "partOfSpeech": wordData["type"],
      "guessed": [],
      "gameOver": false,
      "win": false,
      "screen": 'home',
      "language": 'en',
    };

    this.switchScreen = this.switchScreen.bind(this);
    this.guessLetter = this.guessLetter.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.checkIncorrectGuess = this.checkIncorrectGuess.bind(this);
    this.checkAllGuessed = this.checkAllGuessed.bind(this);
    this.toggleDifficulty = this.toggleDifficulty.bind(this);
    // this.generateWord = this.generateWord.bind(this);
    this.generateWordData = this.generateWordData.bind(this);
    this.updateGraphic = this.updateGraphic.bind(this);
    this.calcTimeRemaining = this.calcTimeRemaining.bind(this);
    this.resetBoard = this.resetBoard.bind(this);
    this.share = this.share.bind(this);
    this.nativeShare = this.nativeShare.bind(this);
    this.showNotification = this.showNotification.bind(this);
    this.appendGraphicText = this.appendGraphicText.bind(this);
    this.returnHome = this.returnHome.bind(this);
    this.getCookie = this.getCookie.bind(this);
    this.setCookie = this.setCookie.bind(this);
    this.checkCookie = this.checkCookie.bind(this);
    this.getStreakCookie = this.getStreakCookie.bind(this);
    this.setStreakCookie = this.setStreakCookie.bind(this);
    this.checkStreakCookie = this.checkStreakCookie.bind(this);
    this.checkTodayIsStreakPlusOne = this.checkTodayIsStreakPlusOne.bind(this);
    this.checkTodayIsLatestStreakDay = this.checkTodayIsLatestStreakDay.bind(this);
    this.updateStreak = this.updateStreak.bind(this);
    this.intToDay = this.intToDay.bind(this);
    this.intToMonth = this.intToMonth.bind(this);
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.getDefinition = this.getDefinition.bind(this);
    this.getGraphicDefinition = this.getGraphicDefinition.bind(this);
    this.clearDefinition = this.clearDefinition.bind(this);
    this.clearGraphicDefinition = this.clearGraphicDefinition.bind(this);
    this.changeLanguage = this.changeLanguage.bind(this);

    this.updateTimer = false;
  }

   // ========= //
  // FUNCTIONS //
 // ========= //

  // generateWord(words) {
  //   let num = Math.floor(Math.random() * (words.length - 1));
  //   let word = words[num].toLowerCase();

  //   return word;
  // }

  generateWordData(arr) {
    let num = Math.floor(Math.random() * (arr.length - 1));
    let wordData = arr[num];

    return wordData;
  }

  generateDailyWord(words) {
    let seed = new Date()
    let string = `${seed.getDate()}-${seed.getMonth()+1}-${seed.getFullYear()}`

    let prng = new Math.seedrandom(string)
    
    let num = Math.floor(prng.quick() * (words.length - 1));
    let word = words[num].toLowerCase();

    return word;
  }

  generateDailyWordData(arr) {
    let seed = new Date()
    let string = `${seed.getDate()}-${seed.getMonth()+1}-${seed.getFullYear()}`

    let prng = new Math.seedrandom(string)
    
    let num = Math.floor(prng.quick() * (arr.length - 1));
    let wordObj = arr[num];

    return wordObj;
  }

  switchScreen(screen) {
    switch(screen) {
      case "practice":
        this.setState({
          screen
        })
        break;
      case "daily":
        this.checkCookie();
        break;
      default:
        this.resetBoard();
        this.setState({
          "screen": "home"
        })
        break;
    }
  }

  returnHome() {
    clearInterval(this.updateTimer)
    this.switchScreen(false)
  }

  toggleDifficulty() {
    let newDifficulty = "medium";
    let newChances = 6;

    switch (this.state.difficulty) {
      case "easy":
        newDifficulty = "medium";
        newChances = 6;
        break;
      case "medium":
        newDifficulty = "hard";
        newChances = 5;
        break;
      case "hard":
        newDifficulty = "legendary";
        newChances = 4;
        break;
      case "legendary":
        newDifficulty = "easy";
        newChances = 7;
        break;
      default:
        newDifficulty = "medium";
        newChances = 6;
        break;
    }

    // Enable definition btn
    let definitionBtn = document.querySelector('.btn--definition');
    if (definitionBtn) {
      definitionBtn.removeAttribute('disabled');
      this.clearDefinition();
    }
    this.clearGraphicDefinition();

    // Update state
    const wordData = this.generateWordData(data);
    this.setState({
      difficulty: newDifficulty,
      chances: newChances,
      "incorrectGuesses": 0,
      "word": wordData["word"].toLowerCase(),
      "definition": wordData["definition"],
      "lang": wordData["language"],
      "partOfSpeech": wordData["type"],
      "guessed": [],
      "gameOver": false,
      "win": false
    })
  }

  checkIncorrectGuess(char) {
    let result = false;
    if (!this.state.word.includes(char)) {
     result = true;
    }
    return result;
  }

  checkAllGuessed(guessed) {
    let result = true;
    this.state.word.split('').forEach((elem, index) => {
      if (!guessed.includes(elem)) {
        result = false;
      }
    })
    return result;
  }

  guessLetter(char) {
    if (this.state.gameOver) {
      return;
    }

    if (this.state.guessed.includes(char)) {
      return;
    };

    let newGuessed = this.state.guessed;
    newGuessed.push(char);

    // Check for all letters guessed
    let allGuessed = this.checkAllGuessed(newGuessed);

    // Check for incorrect guess
    let incorrectGuess = this.checkIncorrectGuess(char);

    let newIncorrectGuesses = this.state.incorrectGuesses;
    if (incorrectGuess) {
      newIncorrectGuesses += 1;
    }

    // Update state
    this.setState({
      guessed: newGuessed,
      incorrectGuesses: newIncorrectGuesses,
      gameOver: newIncorrectGuesses === this.state.chances ? true : allGuessed,
      win: newIncorrectGuesses === this.state.chances ? false : allGuessed
    })
  }

  handleKeyDown = (event) => {
    if (event.keyCode < 65 || event.keyCode > 90) {
      return;
    }

    this.guessLetter(event.key);
  }

  handleClick(e) {
    e.preventDefault();

    let letter = e.target.getAttribute('data-letter');

    this.guessLetter(letter)
  }

  openModal(type) {
    let modal = document.querySelector('.Modal');
    modal.classList.add('open');

    if (type === 'instructions') {
      let container = modal.querySelector('.modal__inner');

      let temp = "";
      temp += `
      <div class="game-information">
        <div class="u-mb--small">
          <p class="u-mb--small"><strong>${translations[this.state.language].information['instructions-title']}</strong></p>
          <p>${translations[this.state.language].information['instructions-content-1']}</p>
          <p>${translations[this.state.language].information['instructions-content-2']}</p>
          <p>${translations[this.state.language].information['instructions-content-3']}</p>
          <p>${translations[this.state.language].information['instructions-content-4']}</p>
        </div>
        <div class="u-mb--medium">
          ${translations[this.state.language].information['word-info-1']}
          ${translations[this.state.language].information['word-info-2']}
        </div>
        <div class="u-mb--medium">
          <p class="u-mb--small"><strong>${translations[this.state.language].information['practice-title']}</strong></p>
          <p>${translations[this.state.language].information['practice-content-1']}</p>
          <p>${translations[this.state.language].information['practice-content-2']}</p>
        </div>
        <div>
          <p class="u-mb--small"><strong>${translations[this.state.language].information['hint-title']}</strong></p>
          <p>${translations[this.state.language].information['hint-content-1']}</p>
          <p>${translations[this.state.language].information['hint-content-2']}</p>
          <p>${translations[this.state.language].information['hint-content-3']}</p>
          <p>${translations[this.state.language].information['hint-content-4']}</p>
        </div>
      </div>
      `;

      container.innerHTML = temp;

      modal.appendChild(container)
    }
  }

  closeModal() {
    let modal = document.querySelector('.Modal');
    let innerModal = modal.querySelector('.modal__inner');
    innerModal.innerHTML = '';
    modal.classList.remove('open');
  }

  showNotification(success, text) {
    let graphic = document.querySelector('.Graphic');

    let currentNote = graphic.querySelector('.notification');
    if (currentNote) {
      return;
    }

    let note  = document.createElement('p');
    note.classList.add('notification')

    if (!success) {
      note.classList.add('error')
    }

    note.innerHTML = text;

    graphic.appendChild(note);

    if (success) {
      setTimeout(() => {
        graphic.removeChild(note);
      }, 3500);
    }
  }

  appendGraphicText(title, textResult, emojiResult) {
    let graphic = document.querySelector('.Graphic');

    let copyBox = graphic.querySelector('.manual-copy-text');
    if (copyBox) {
      return;
    }

    let div = document.createElement('div');
    div.classList.add('manual-copy-text')


    div.innerHTML = `
    <p>${title}</p>
    <p>${textResult}</p>
    <p>${emojiResult}</p>
    `;

    graphic.appendChild(div);
  }

  share() {
    let today = new Date().toISOString().slice(0, 10);

    let title = `Hangle ${today}`

    let link = 'https://wordhangle.com';

    let remainingChances = this.state.chances - this.state.incorrectGuesses;
    let chanceHTML = "";
    for (let i = 0; i < remainingChances; i++) {
        chanceHTML += "💚";
    }
    for (let i = 0; i < this.state.incorrectGuesses; i++) {
        chanceHTML += "💔";
    }

    let textResult = chanceHTML;

    let emojiResult = '';
    let wordChars = this.state.word.split('');
    for (let i = 0; i < wordChars.length; i++) {
      if (this.state.guessed.includes(wordChars[i])) {
        emojiResult += '🟩';
      } else {
        emojiResult += '❌';
      }
    }

    let copiedResult = title + '\n' + textResult + '\n' + emojiResult + '\n' + link + '\n';

    navigator.clipboard.writeText(copiedResult).then(() => {
      /* clipboard successfully set */
      this.showNotification(true, 'Successfully coppied to clipboard!')
    }, () => {
      /* clipboard write failed */
      this.showNotification(false, 'Copy doesn\'t work in this browser... Try copying manually!')
      this.appendGraphicText(title, textResult, emojiResult);
    });
  }

  async nativeShare() {
    let today = new Date().toISOString().slice(0, 10);
    let title = `Hangle ${today}`
    let link = 'https://wordhangle.com';

    let remainingChances = this.state.chances - this.state.incorrectGuesses;
    let chanceHTML = "";
    for (let i = 0; i < remainingChances; i++) {
        chanceHTML += "💚";
    }
    for (let i = 0; i < this.state.incorrectGuesses; i++) {
        chanceHTML += "💔";
    }

    let textResult = chanceHTML;

    let emojiResult = '';
    let wordChars = this.state.word.split('');
    for (let i = 0; i < wordChars.length; i++) {
      if (this.state.guessed.includes(wordChars[i])) {
        emojiResult += '🟩';
      } else {
        emojiResult += '❌';
      }
    }

    let text = title + '\n' + textResult + '\n' + emojiResult

    try {
      await navigator.share({
        url: link,
        title: title,
        text: text
      });
    } catch (err) {
      if (err.name === 'AbortError') {
        console.log('Share operation cancelled by the user.');
      } else {
        console.error('Error sharing content: ', {err})
      }
    }
  }

  resetBoard() {
    let chances = '6';
    switch (this.state.difficulty) {
      case "easy":
        chances = 7;
        break;
      case "medium":
        chances = 6;
        break;
      case "hard":
        chances = 5;
        break;
      case "legendary":
        chances = 4;
        break;
      default:
        chances = 6;
    }

    const graphic = document.querySelector('.Graphic')
    graphic.classList.add('hidden');
    graphic.classList.remove('animate', 'animate__jackInTheBox');

    let newWordData = this.generateWordData(data);
    let newWord = newWordData["word"].toLowerCase();
    let definition = newWordData["definition"];
    let lang = newWordData["language"];
    let partOfSpeech = newWordData["type"];

    // Enable definition btn
    let definitionBtn = document.querySelector('.btn--definition');
    if (definitionBtn) {
      definitionBtn.removeAttribute('disabled');
      this.clearDefinition();
    }
    this.clearGraphicDefinition();

    this.setState({
      "chances": chances,
      "incorrectGuesses": 0,
      "word": newWord,
      "definition": definition,
      "lang": lang,
      "partOfSpeech": partOfSpeech,
      "guessed": [],
      "gameOver": false,
      "win": false
    });
  }

  async updateGraphic(win) {
    const graphic = document.querySelector('.Graphic')
    const result = document.querySelector('#result')
    const answer = document.querySelector('#answer')
    const streak = document.querySelector('#streak')
    const timeRemainingElem = document.querySelector('[data-time-remaining]')

    if (win) {
      result.innerHTML = "Winner!"
    } else {
      result.innerHTML = "You Lose!"
    }

    graphic.classList.remove('hidden');
    graphic.classList.add('animate', 'animate__jackInTheBox');
    answer.innerHTML = this.state.word;

    if (streak) {
      let res = await this.checkStreakCookie();
      if (res.streakDays > 0) {
        streak.innerHTML = `Current Streak:<br/><span>${res.streakDays} day${res.streakDays > 1 ? 's' : ''}</span>`;
        setTimeout(() => {
          streak.classList.remove('hidden');
          streak.classList.add('animate', 'animate__zoomIn');
        }, 500);
      }
    }

    if (timeRemainingElem) {
      this.updateTimer = setInterval(() => {
        timeRemainingElem.innerHTML = this.calcTimeRemaining();
      }, 1000);
    }

    this.getGraphicDefinition(this.state.word, true)
 
    if (win) {
      document.dispatchEvent(new CustomEvent('releaseConfetti'));
    }
  }

  calcTimeRemaining() {
    let today = new Date();

    let tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    tomorrow.setHours(0,0,0,0);

    let diffMs = (tomorrow - today);

    function padTo2Digits(num) {
      return num.toString().padStart(2, '0');
    }
    
    function convertMsToTime(milliseconds) {
      let seconds = Math.floor(milliseconds / 1000);
      let minutes = Math.floor(seconds / 60);
      let hours = Math.floor(minutes / 60);
  
      seconds = seconds % 60;
      minutes = minutes % 60;
  
      hours = hours % 24; // convert to 12 hour time
  
      return `${padTo2Digits(hours)}h ${padTo2Digits(minutes)}m ${padTo2Digits(seconds)}s`;
    }

    let timeRemaining = convertMsToTime(diffMs);

    return timeRemaining;
  }

  intToDay(int) {
    let result;
    switch(int) {
      case 0:
        result = 'Mon';
        break;
      case 1:
        result = 'Tue';
        break;
      case 2:
        result = 'Wed';
        break;
      case 3:
        result = 'Thu';
        break;
      case 4:
        result = 'Fri';
        break;
      case 5:
        result = 'Sat';
        break;
      case 6:
        result = 'Sun';
        break;
      default:
        result = 'Mon';
        break;
    }
    return result;
  }

  intToMonth(int) {
    let result;
    switch(int) {
      case 0:
        result = 'Jan';
        break;
      case 1:
        result = 'Feb';
        break;
      case 2:
        result = 'Mar';
        break;
      case 3:
        result = 'Apr';
        break;
      case 4:
        result = 'May';
        break;
      case 5:
        result = 'Jun';
        break;
      case 6:
        result = 'Jul';
        break;
      case 7:
        result = 'Aug';
        break;
      case 8:
        result = 'Sep';
        break;
      case 9:
        result = 'Oct';
        break;
      case 10:
        result = 'Nov';
        break;
      case 11:
        result = 'Dec';
        break;
      default:
        result = 'Jan';
        break;
    }
    return result;
  }

  setCookie() {
    let cname, cvalue, exdays;
    if (!cname) {
      let today = new Date()
      let today_date = `${today.getFullYear()}-${today.getMonth() + 1}-${today.getDate()}`;
      cname = `daily-hangle-${today_date}`;
    }
    if (!cvalue) {
      let saveState = {
        "chances": this.state.chances,
        "incorrectGuesses": this.state.incorrectGuesses,
        "word": this.state.word,
        "definition": this.state.definition,
        "lang": this.state.lang,
        "partOfSpeech": this.state.partOfSpeech,
        "guessed": this.state.guessed,
        "gameOver": this.state.gameOver,
        "win": this.state.win,
      };
      saveState = JSON.stringify(saveState);

      const encodedSaveState = encodeURIComponent(saveState) // handle reserved characters for the cookie

      cvalue = encodedSaveState
    }

    if (!exdays) {
      exdays = 2;
    }

    const d = new Date();
    d.setDate(d.getDate() + 1); // add one day
    // d.setTime(d.getTime() + (exdays*24*60*60*1000));
    let expires = "expires="+ d.toUTCString(); // expires exactly 24 hours after being set
    // let expires = `expires=${this.intToDay(d.getDay())}, ${d.getDate() +1} ${this.intToMonth(d.getMonth())} ${d.getFullYear()} ${d.getHours()}:${d.getMinutes()}:${d.getSeconds()} GMT`;

    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }

  async setStreakCookie(cname='daily-hangle-streak', cvalue=0, exdays=2) {
    // cvalue will come in as the current day streak. Append to current date.
    // exdays at 2 will cover 12am on day 1 and 11:59pm on day 2.

    // Include today's date with cookie
    let today = new Date()
    let today_date = `${today.getDate()}-${today.getMonth()+1}-${today.getFullYear()}`;

    cvalue = `${today_date}|${cvalue}`;
    
    const d = new Date();
    d.setDate(d.getDate() + exdays); // should be 2 days (48h) to account for 12:00 am on day one and 11:59pm on day two
    let expires = "expires="+ d.toUTCString();
    // let expires = `expires=${this.intToDay(d.getDay())}, ${d.getDate() +1} ${this.intToMonth(d.getMonth())} ${d.getFullYear()} ${d.getHours()}:${d.getMinutes()}:${d.getSeconds()} GMT`;

    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }

  getCookie() {
    let cname;
    if (!cname) {
      let today = new Date()
      let today_date = `${today.getFullYear()}-${today.getMonth() + 1}-${today.getDate()}`;
      cname = `daily-hangle-${today_date}`;
    }

    let name = cname + "=";
    let ca = document.cookie.split(';');
    for(let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  async getStreakCookie() {
    // Cookie will be returned in the format: "[YYYY-MM-D]|[streak: int]"
    // no zero padding on date

    let cname;
    if (!cname) {
      cname = 'daily-hangle-streak';
    }

    let name = cname + "=";
    let ca = document.cookie.split(';');
    for(let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  async checkCookie() {
    let lastState = this.getCookie();

    if (lastState !== "") {
      lastState = decodeURIComponent(lastState)
    }

    if (lastState !== "") {
      lastState = await JSON.parse(lastState);

      this.setState({
        "chances": lastState.chances,
        "incorrectGuesses": lastState.incorrectGuesses,
        "word": lastState.word,
        "definition": lastState.definition,
        "lang": lastState.lang,
        "partOfSpeech": lastState.partOfSpeech,
        "guessed": lastState.guessed,
        "gameOver": lastState.gameOver,
        "win": lastState.win,
        "screen": "daily",
      })
    } else {
      const wordData = this.generateDailyWordData(data)
      this.setState({
        "chances": 6,
        "incorrectGuesses": 0,
        "wordData": wordData,
        "word": wordData["word"].toLowerCase(),
        "definition": wordData["definition"],
        "lang": wordData["language"],
        "partOfSpeech": wordData["type"],
        "guessed": [],
        "gameOver": false,
        "win": false,
        "screen": "daily",
      })
    }
  }

  async checkStreakCookie() {
    // Cookie will be returned in the format: "[DD-MM-YYYY]|[streak: int]"
    // no zero padding on date
    let currentStreak = await this.getStreakCookie();

    if (currentStreak !== "") {
      const lastDate = currentStreak.split('|')[0];
      let streakDays = currentStreak.split('|')[1];
      streakDays = parseInt(streakDays);

      return {lastDate, streakDays}
    }

    // No current streak saved or previous streak ended
    return 0;
  }

  checkTodayIsLatestStreakDay(dateStampFromCookie) {
    const today = new Date();
    let today_string = `${today.getDate()}-${today.getMonth()+1}-${today.getFullYear()}`

    if (dateStampFromCookie === today_string) {
      return true;
    }

    return false;
  }

  checkTodayIsStreakPlusOne(dateStampFromCookie) { // of the form DD-MM-YYYY
    const today = new Date();

    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);

    let yesterday_string = `${yesterday.getDate()}-${yesterday.getMonth()+1}-${yesterday.getFullYear()}`

    if (dateStampFromCookie === yesterday_string) {
      return true;
    }

    return false;
  }

  async updateStreak(result) { // either "win" or "lose"
    if (result === "lose") {
      await this.setStreakCookie() // defaults zero it out with today's date
    }

    if (result === "win") {
      // Check current streak
      const res = await this.checkStreakCookie()

      const useCurrentStreak = this.checkTodayIsLatestStreakDay(res.lastDate);
      const continueStreak = this.checkTodayIsStreakPlusOne(res.lastDate);

      let newStreak = 1; // default for fresh start
 
      if (useCurrentStreak) {
        newStreak = res.streakDays // completed today's daily challenge already, user is viewing challege again
      } else if (continueStreak) {
        newStreak = res.streakDays + 1; // just completed today's daily challenge after yesterday's success
      }

      await this.setStreakCookie('daily-hangle-streak', newStreak, 2);
    }
  }

  clearDefinition() {
    let definitionWrapper = document.querySelector('.definition-wrapper');
    if (!definitionWrapper) return;

    definitionWrapper.innerHTML = '';
  }

  clearGraphicDefinition() {
    let definitionWrapper = document.querySelector('.definition-wrapper--graphic');
    if (!definitionWrapper) return;

    definitionWrapper.innerHTML = '';
  }

  async getDefinition(word) {
    // Disable btn
    let definitionBtn = document.querySelector('.btn--definition');
    definitionBtn.setAttribute('disabled', true);

    // Check for definition wrapper
    let definitionWrapper = document.querySelector('.definition-wrapper');

    if (!definitionWrapper) return;
    if (definitionWrapper.innerHTML !== '') return;

    // Output definition
    this.clearDefinition();

    let partOfSpeech = this.state.partOfSpeech;
    let definition = this.state.definition;
    let lang = this.state.lang;

    let html = '';
    html += `<p>${partOfSpeech}.</p>`;
    html += `<p>"${definition}"</p>`;
    html += `<p>[${lang}]</p>`;

    definitionWrapper.innerHTML = html;

    let newIncorrectGuesses = this.state.incorrectGuesses + 1;
    this.setState({
      incorrectGuesses: newIncorrectGuesses
    })
  }

  async getGraphicDefinition(word) {
    // Check for definition wrapper
    let definitionWrapper = document.querySelector('.definition-wrapper--graphic');

    if (!definitionWrapper) return;
    if (definitionWrapper.innerHTML !== '') return;

    // Output definition
    this.clearGraphicDefinition();

    let partOfSpeech = this.state.partOfSpeech;
    let definition = this.state.definition;
    let lang = this.state.lang;

    let html = '';
    html += `<p>${partOfSpeech}.</p>`;
    html += `<p>"${definition}"</p>`;
    html += `<p>[${lang}]</p>`;

    definitionWrapper.innerHTML = html;
  }

  changeLanguage(lang) {
    this.setState({
      'language': lang
    })
  }

   // ================= //
  // LIFECYCLE METHODS //
 // ================= //

  componentDidMount(){
    this.generateWordData(data);

    document.addEventListener("keydown", this.handleKeyDown);
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.handleKeyDown);
  }

  async componentDidUpdate() {

    if (this.state.screen === 'daily') {
      this.setCookie();
    }

    if (this.state.screen === 'practice') {
      if (this.state.incorrectGuesses >= this.state.chances - 1) {
        // Disable definition btn
        let definitionBtn = document.querySelector('.btn--definition');
        if (definitionBtn) {
          definitionBtn.setAttribute('disabled', true);
        }
      }
    }

    // Check state for win/lose conditions
    if (!this.state.gameOver) {
      return;
    }

    if (this.state.incorrectGuesses >= this.state.chances) {
      if (this.state.screen === 'daily') {
        await this.updateStreak("lose")
      }

      this.updateGraphic(false);
    }

    if (this.state.win) {
      if (this.state.screen === 'daily') {
        await this.updateStreak("win")
      }

      this.updateGraphic(true)
    }
  }

  render() {
    return (
      <div className="App">

        {
          this.state.screen === 'home' ?
          <Home 
            switchScreen={this.switchScreen}
            openModal={this.openModal}
            information={translations[this.state.language].information['info-btn']}
          /> : ''
        }
        {
          this.state.screen === 'daily' ?
            <Daily
              returnHome={this.returnHome}
              state={this.state}
              guessLetter={this.guessLetter}
              handleClick={this.handleClick}
              checkIncorrectGuess={this.checkIncorrectGuess}
              checkAllGuessed={this.checkAllGuessed}
              toggleDifficulty={this.toggleDifficulty}
              generateWord={this.generateWord}
              updateGraphic={this.updateGraphic}
              share={this.share}
              nativeShare={this.nativeShare}
              setCookie={this.setCookie}
              getCookie={this.getCookie}
              checkCookie={this.checkCookie}
              getGraphicDefinition={this.getGraphicDefinition}
            /> : ''
        }
        {
          this.state.screen === 'practice' ?
            <Practice
              returnHome={this.returnHome}
              state={this.state}
              guessLetter={this.guessLetter}
              handleClick={this.handleClick}
              checkIncorrectGuess={this.checkIncorrectGuess}
              checkAllGuessed={this.checkAllGuessed}
              toggleDifficulty={this.toggleDifficulty}
              generateWordData={this.generateWordData}
              updateGraphic={this.updateGraphic}
              resetBoard={this.resetBoard}
              getDefinition={this.getDefinition}
              getGraphicDefinition={this.getGraphicDefinition}
            /> : ''
        }

{/*
        <div className='language-wrapper'>
          <button title='English' className={this.state.language === 'en' ? 'language-toggle active language-toggle--en' : 'language-toggle language-toggle--en'} onClick={() => this.changeLanguage('en')} data-language="en"></button>
          <button title='Korean' className={this.state.language === 'kr' ? 'language-toggle active language-toggle--kr' : 'language-toggle language-toggle--kr'} onClick={() => this.changeLanguage('kr')} data-language="kr"></button>
          <button title='Japanese' className={this.state.language === 'jp' ? 'language-toggle active language-toggle--jp' : 'language-toggle language-toggle--jp'} onClick={() => this.changeLanguage('jp')} data-language="jp"></button>
        </div>
*/}
        <div className='Modal'>
          <button className='close-modal' onClick={() => this.closeModal()}>X</button>
          <div className='modal__inner'></div>
        </div>

      </div>
    );
  }
}

export default App;
